type PspConfigData = {
  PSPTitleAndIcon?: {title?: string; icon?: string}
  logoPSP?: string
  logoImagePSP?: string
  theme?: {primaryColor?: string}
}

// The Web App Manifest and its icon are served by psp-backend as real, publicly-fetchable
// URLs, resolved per-PSP from the request Host (see psp-backend src/endpoints/manifest). This
// is what lets any installer — the browser's manifest loader, Android's server-side WebAPK
// minting service, iOS — read the correct tenant branding; a manifest/icon reachable only
// through this page's Service Worker is invisible to those external fetchers.
const MANIFEST_URL = '/psp-backend/manifest'
// iOS ignores data: URIs for apple-touch-icon and needs a real image URL, so the same public
// backend route also serves the raw PNG via ?asset=icon.
const APPLE_TOUCH_ICON_URL = '/psp-backend/manifest?asset=icon'

export function applyDynamicManifest(config: PspConfigData): void {
  const title = config.PSPTitleAndIcon?.title
  const themeColor = config.theme?.primaryColor ?? '#5BA77E'

  setManifestLink(MANIFEST_URL)
  setAppleTouchIcon(APPLE_TOUCH_ICON_URL)
  setMeta('apple-mobile-web-app-capable', 'yes')
  setMeta('apple-mobile-web-app-status-bar-style', 'default')
  setMeta('theme-color', themeColor)

  // Only override the title when we actually have the PSP's. Otherwise leave it to the per-PSP
  // manifest name (the static <link rel="manifest"> already points at psp-backend) — setting a
  // generic default for apple-mobile-web-app-title would override that correct manifest name on
  // iOS. index.html intentionally ships no static apple-mobile-web-app-title for the same reason.
  if (title) {
    document.title = title
    setMeta('apple-mobile-web-app-title', title)
  }
}

function setManifestLink (href: string): void {
  let el = document.querySelector<HTMLLinkElement>('link[rel="manifest"]')
  if (!el) {
    el = document.createElement('link')
    el.rel = 'manifest'
    document.head.appendChild(el)
  }
  el.href = href
}

function setMeta(name: string, content: string): void {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.name = name
    document.head.appendChild(el)
  }
  el.content = content
}

function setAppleTouchIcon(href: string): void {
  let el = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]')
  if (!el) {
    el = document.createElement('link')
    el.rel = 'apple-touch-icon'
    document.head.appendChild(el)
  }
  el.href = href
}
